import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment'; 
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { constants } from 'os';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  

  /*intercept( request: HttpRequest<any>, next: HttpHandler ):                   Observable<HttpEvent<any>> {
    console.log("intercept",request);
    return next.handle(request);
  }*/


  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

    const requestUrl: Array<any> =  req.url.split("/");
    const apiUrl: Array<any> = environment.serviceApi.split("/"); 

    //console.log("requestUrl", requestUrl ); //aPAGAR
    //console.log("apiUrl", apiUrl ); //aPAGAR
   
    const token = localStorage.getItem('token');
    //console.log("token",token); //aPAGAR
    
    if(token && (requestUrl[2] == apiUrl[2])){

        const dupReq = req.clone({
          headers: req.headers.set('Authorization', `bearer ${token}`)
        });
        return next.handle(dupReq);

    }else{
        return next.handle(req);
    }
   //"bearer"
  }
}